module.exports = __webpack_public_path__ + "img/onst.6b8e38a6.jpg";